<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <el-tabs value="1" v-model="mediaType">
        <el-tab-pane label="网络媒体" name="1"><media v-if="mediaType==1"></media> </el-tab-pane>
        <el-tab-pane label="自媒体" name="2"><self v-if="mediaType==2"></self> </el-tab-pane>
        <el-tab-pane label="微信公众号" name="3"><Offical v-if="mediaType==3"></Offical> </el-tab-pane>
        <el-tab-pane label="微博" name="4"><Bolg v-if="mediaType==4"></Bolg> </el-tab-pane>
        <el-tab-pane label="百科问答知识营销" name="5"><Wiki v-if="mediaType==5"></Wiki> </el-tab-pane>
        <el-tab-pane label="朋友圈社群" name="6"><Wechat v-if="mediaType==6"></Wechat> </el-tab-pane>
        <el-tab-pane label="短视频" name="7"><Tiktok v-if="mediaType==7"></Tiktok> </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import HeadTop from "../components/HeadTop";
import media from "./publish/mediaPublish.vue";
import self from "./publish/SelfPublish.vue";
import Offical from "./publish/OfficalPublish.vue";
import Bolg from "./publish/BolgPublish.vue";
import Tiktok from "./publish/TiktokPublish.vue";
import Wiki from "./publish/WikiPublish.vue";
import Wechat from "./publish/WechatPublish.vue";
export default {
  data() {
    return {
      mediaType: "",
    };
  },
  components: {media,self,Offical,Bolg,Wiki,Tiktok,Wechat,HeadTop},
  created() {
    this.demoYB().then(val => {
      console.log("val",val)
    }).catch(val => {
      console.log("val",val)
    })
  let type= localStorage.getItem("remediaType") || "";
    if (type&&type !== "") {
      this.mediaType = type+"";
      localStorage.removeItem("remediaType");
    }else{
       this.mediaType = "1";
    }
  },
  methods: {
    demoYB(){
      return new Promise((resolve,reject)=>{
         resolve("ok")
         reject("no")
      })
    },
    toPublish(num) {
      if (num == 1) {
        this.$router.push({ path: "/mediaPublish" });
      } else if (num == 2) {
        this.$router.push({ path: "/SelfPublish" });
      } else if (num == 3) {
        this.$router.push({ path: "/OfficalPublish" });
      } else if (num == 4) {
        this.$router.push({ path: "/BolgPublish" });
      } else if (num == 5) {
        this.$router.push({ path: "/WikiPublish" });
      } else if (num == 6) {
        this.$router.push({ path: "/WechatPublish" });
      } else if (num == 7) {
        this.$router.push({ path: "/TiktokPublish" });
      }
    },
  },
};
</script>
<style scoped>
.btnBox {
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
}
.btn {
  height: 100px;
  width: 120px;
}
</style>
<style>
.el-upload-dragger .el-icon-upload{
  font-size:46px!important;
  line-height:0px!important;
}
.el-upload-dragger{
  height: 120px!important;
}
.el-upload__tip{
      margin-top: -10px!important;
    margin-bottom: -20px!important;
}
</style>
